import appConfig from '@/features/app/constants/app-config';
import Cookies from 'js-cookie';

/**
 * Check if the client is already migrated to the new cookie storage
 *
 * @returns
 */
export default function canClientUseCookieTokenStorage() {
  return Cookies.get(appConfig.accessTokenExpireDateKey) !== undefined;
}
